module.exports = "/img/_/_/_/assets/images/creeper/book/common//8.jpg?4652c0ae6c58ac63870064f630bb9564";